module.exports = __webpack_public_path__ + "media/images/page/development_ic-87a1689aa691d81dd3b5e0df20c945cc.svg";